module.exports = __webpack_public_path__ + "static/media/feature.1bd0049c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Koombana/feature.jpg
// module id = 297
// module chunks = 0